@if (pkg()) {
  <p-dialog
    [(visible)]="isVisible"
    [modal]="true"
    [closable]="false"
    styleClass="buy-package-dialog"
  >
    <ng-template #header>
      <div class="flex align-items-center justify-content-between w-full">
        <div class="flex justify-content-center align-items-center dialog-header-icon">
          <app-check-circle stroke="#414651" width="20px" height="20px"></app-check-circle>
        </div>
        <app-x-close stroke="#ADB0B8" width="12" height="12" class="cursor-pointer" (click)="onCancel()"></app-x-close>
      </div>
    </ng-template>

    <div class="flex flex-column">
      <div class="text-lg-semibold text-gray-900">Potvrda zahteva za kupovinu</div>
      <div class="mt-1 text-sm-regular text-gray-600">
        Želite da zatražite kupovinu <span class="text-sm-semibold text-gray-700">{{ packageName() }}</span> paketa?
      </div>

      <div class="mt-4 summary-box">
        <div class="flex align-items-center justify-content-between">
          <div class="flex align-items-center gap-3">
            <div class="flex justify-content-center align-items-center package-icon">
              <app-cube-01 stroke="#414651"></app-cube-01>
            </div>
            <div class="flex flex-column">
              <span class="text-sm-semibold text-gray-900">{{ packageName() }}</span>
              <span class="text-sm-regular text-gray-600">{{ pkg().hours }}h</span>
            </div>
          </div>
          <span class="display-sm-semibold text-gray-900">{{ pkg().price | currencyNumber }}</span>
        </div>

        <hr class="summary-divider" />

        <div class="flex align-items-center justify-content-between">
          <div class="flex align-items-center gap-1">
            <span class="text-sm-regular text-gray-600">Ukupno sati</span>
            <app-info-circle
              stroke="#ADB0B8"
              pTooltip="Ukupan broj sati svih aktivnih paketa"
              tooltipPosition="top"
            ></app-info-circle>
          </div>
          <span class="text-sm-medium text-gray-700">{{ pkg().hours }}h</span>
        </div>
      </div>
    </div>

    <ng-template #footer>
      <div class="flex justify-content-end align-items-center gap-2 w-full">
        <app-button
          [btnSeverity]="ButtonSeverity.SECONDARY"
          [btnSize]="ButtonSize.MD"
          (btnClicked)="onCancel()"
        >
          <span class="text-sm-semibold text-gray-900">Otkaži</span>
        </app-button>
        <app-button
          [btnSeverity]="ButtonSeverity.PRIMARY"
          [btnSize]="ButtonSize.MD"
          (btnClicked)="onConfirm()"
        >
          <span class="text-sm-semibold text-white">Potvrdi zahtev</span>
        </app-button>
      </div>
    </ng-template>
  </p-dialog>
}
